module.exports = __webpack_public_path__ + "img/5.e1f2355b.png";